export const USER_PROFILE_REQUEST = "USER_PROFILE_REQUEST";
export const USER_PROFILE_RECEIVE = "USER_PROFILE_RECEIVE";
export const USER_PROFILE_FAILURE = "USER_PROFILE_FAILURE";
export const RESET_USER_PROFILE = "RESET_USER_PROFILE";
